import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuiasService {

  //data guias

//dataTipoMoneda
private dataTipoMoneda = new BehaviorSubject('');
TipoMoneda = this.dataTipoMoneda.asObservable();

setDataTipoMoneda(data) {
  this.dataTipoMoneda.next(data);
}

//dataTipoBanco
private dataTipoBanco = new BehaviorSubject('');
TipoBanco = this.dataTipoBanco.asObservable();

setDataTipoBanco(data) {
  this.dataTipoBanco.next(data);
}

//dataTipoBancoIF
private dataTipoBancoIF = new BehaviorSubject('');
TipoBancoIF = this.dataTipoBancoIF.asObservable();

setDataTipoBancoIF(data) {
  this.dataTipoBancoIF.next(data);
}

//dataTipoPago
private dataTipoPago = new BehaviorSubject('');
TipoPago = this.dataTipoPago.asObservable();

setDataTipoPago(data) {
  this.dataTipoPago.next(data);
} 

//dataTipoContacto
 private dataTipoContacto = new BehaviorSubject('');
 TipoContacto = this.dataTipoContacto.asObservable();

 setDataTipoContacto(data) {
   this.dataTipoContacto.next(data);
 } 
//dataTipoDocumento
private dataTipoDocumento = new BehaviorSubject('');
TipoDocumento = this.dataTipoDocumento.asObservable();

setDataTipoDocumento(data) {
  this.dataTipoDocumento.next(data);
}
//dataIgvExonerado
private dataIgvExonerado = new BehaviorSubject('');
IgvExonerado = this.dataIgvExonerado.asObservable();

setDataIgvExonerado(data) {
  this.dataIgvExonerado.next(data);
}     
//dataRolContacto
private dataRolContacto = new BehaviorSubject('');
RolContacto = this.dataRolContacto.asObservable();

setDataRolContacto(data) {
  this.dataRolContacto.next(data);
}

//dataTipoCuenta
private dataTipoCuenta = new BehaviorSubject('');
TipoCuenta = this.dataTipoCuenta.asObservable();

setDataTipoCuenta(data) {
  this.dataTipoCuenta.next(data);
}

//dataTipoComprobante
private dataTipoComprobante = new BehaviorSubject('');
TipoComprobante = this.dataTipoComprobante.asObservable();

setDataTipoComprobante(data) {
  this.dataTipoComprobante.next(data);
}

//dataTipoComprobanteIF
private dataTipoComprobanteIF = new BehaviorSubject('');
TipoComprobanteIF = this.dataTipoComprobanteIF.asObservable();

setDataTipoComprobanteIF(data) {
  this.dataTipoComprobanteIF.next(data);

}

//dataComprobanteEmitido
private dataComprobanteEmitido = new BehaviorSubject('');
ComprobanteEmitido = this.dataComprobanteEmitido.asObservable();

setDataComprobanteEmitido(data) {
  this.dataComprobanteEmitido.next(data);
}

//dataComprobanteContabilizado
private dataComprobanteContabilizado = new BehaviorSubject('');
ComprobanteContabilizado = this.dataComprobanteContabilizado.asObservable();

setDataComprobanteContabilizado(data) {
  this.dataComprobanteContabilizado.next(data);
}

 //dataCondicion
 private dataCondicion = new BehaviorSubject('');
 Condicion = this.dataCondicion.asObservable();

 setDataCondicion(data) {
   this.dataCondicion.next(data);
 }  

 //dataTipoConformidad
 private dataTipoConformidad = new BehaviorSubject('');
 TipoConformidad = this.dataTipoConformidad.asObservable();

 setDataTipoConformidad(data) {
   this.dataTipoConformidad.next(data);
 } 

//dataTipoEmision
private dataTipoEmision = new BehaviorSubject('');
TipoEmision = this.dataTipoEmision.asObservable();

setDataTipoEmision(data) {
  this.dataTipoEmision.next(data);
}

//dataRetencionBase
private dataRetencionBase = new BehaviorSubject('');
RetencionBase = this.dataRetencionBase.asObservable();

setDataRetencionBase(data) {
  this.dataRetencionBase.next(data);
}
  
//dataRetencion
private dataRetencion = new BehaviorSubject('');
Retencion = this.dataRetencion.asObservable();

setDataRetencion(data) {
  this.dataRetencion.next(data);
}

//dataTipoXls
private dataTipoXls = new BehaviorSubject('');
TipoXls = this.dataTipoXls.asObservable();

setDataTipoXls(data) {
  this.dataTipoXls.next(data);
} 

//dataTipoPlanilla
private dataTipoPlanilla = new BehaviorSubject('');
TipoPlanilla = this.dataTipoPlanilla.asObservable();

setDataTipoPlanilla(data) {
  this.dataTipoPlanilla.next(data);
}

//dataParticipante
private dataParticipante = new BehaviorSubject('');
Participante = this.dataParticipante.asObservable();

setDataParticipante(data) {
  this.dataParticipante.next(data);
}

//dataRutTitular
private dataRutTitular = new BehaviorSubject('');
RutTitular = this.dataRutTitular.asObservable();

setDataRutTitular(data) {
  this.dataRutTitular.next(data);
}

//dataTipoSolicitud
private dataTipoSolicitud = new BehaviorSubject('');
TipoSolicitud = this.dataTipoSolicitud.asObservable();

setDataTipoSolicitud(data) {
  this.dataTipoSolicitud.next(data);
}

//dataTipoOperacion
private dataTipoOperacion = new BehaviorSubject('');
TipoOperacion = this.dataTipoOperacion.asObservable();

setDataTipoOperacion(data) {
  this.dataTipoOperacion.next(data);
}

//dataTipoPagoCPE
private dataTipoPagoCPE = new BehaviorSubject('');
TipoPagoCPE = this.dataTipoPagoCPE.asObservable();

setDataTipoPagoCPE(data) {
  this.dataTipoPagoCPE.next(data);
}

//dataTipoOperacioNC
private dataTipoOperacioNC = new BehaviorSubject('');
TipoOperacionNC = this.dataTipoOperacioNC.asObservable();

setDataTipoOperacioNC(data) {
  this.dataTipoOperacioNC.next(data);
}

//dataTipoOperacionND
private dataTipoOperacionND = new BehaviorSubject('');
TipoOperacionND = this.dataTipoOperacionND.asObservable();

setDataTipoOperacionND(data) {
  this.dataTipoOperacionND.next(data);
}
//dataTipoAdjunto
private dataTipoAdjunto = new BehaviorSubject('');
TipoAdjunto = this.dataTipoAdjunto.asObservable();

setDataTipoAdjunto(data) {
  this.dataTipoAdjunto.next(data);
}


//dataRepresentanteIF
private dataRepresentanteIF = new BehaviorSubject('');
RepresentanteIF = this.dataRepresentanteIF.asObservable();

setDataRepresentanteIF(data) {
  this.dataRepresentanteIF.next(data);
}

//dataRepresentanteCLI
private dataRepresentanteCLI = new BehaviorSubject('');
RepresentanteCLI = this.dataRepresentanteCLI.asObservable();

setDataRepresentanteCLI(data) {
  this.dataRepresentanteCLI.next(data);
}


//dataTipoServicio
private dataTipoServicio = new BehaviorSubject<any[]>([]);
TipoServicio = this.dataTipoServicio.asObservable();

setDataTipoServicio(data: any[]) {
  this.dataTipoServicio.next(data || []);
}

//dataEntidadFinanciera
private dataEntidadFinanciera = new BehaviorSubject('');
EntidadFinanciera = this.dataEntidadFinanciera.asObservable();

setDataEntidadFinanciera(data) {
  this.dataEntidadFinanciera.next(data);
}

//dataTipoFacturacion
private dataTipoFacturacion = new BehaviorSubject('');
TipoFacturacion = this.dataTipoFacturacion.asObservable();

setDataTipoFacturacion(data) {
  this.dataTipoFacturacion.next(data);
}

private catalogLoadTrigger = new Subject<void>();
catalogLoadTrigger$ = this.catalogLoadTrigger.asObservable();

triggerCatalogLoad() {
  this.catalogLoadTrigger.next();
}

}
